import { createElement as e, useReducer as t, useMemo as r, useCallback as i } from "react";

import n from "react-ssr-prepass";

import { ssrExchange as a, dedupExchange as l, cacheExchange as o, fetchExchange as s, Provider as u } from "urql";

import { createClient as p } from "@urql/core";

var f = null;

function resetClient() {
  f = null;
}

function initUrqlClient(e, t) {
  var r = "undefined" == typeof window;
  if (r || !f) {
    (f = p({
      ...e,
      suspense: t && (r || e.suspense)
    })).toJSON = () => null;
  }
  return f;
}

var v;

function withUrqlClient(p, f) {
  if (!f) {
    f = {};
  }
  return d => {
    var q = Boolean((d.getInitialProps || f.ssr) && !f.neverSuspend);
    var WithUrql = ({pageProps: n, urqlClient: C, urqlState: g, ...w}) => {
      var [c, m] = t((e => e + 1), 0);
      var h = n && n.urqlState || g;
      var y = r((() => {
        if (C && !c) {
          return C;
        }
        if (!v || "undefined" == typeof window) {
          v = a({
            initialState: h,
            isClient: !0,
            staleWhileRevalidate: "undefined" != typeof window ? f.staleWhileRevalidate : void 0
          });
        } else if (!c) {
          v.restoreData(h);
        }
        var e = p(v);
        if (!e.exchanges) {
          e.exchanges = [ l, o, v, s ];
        }
        return initUrqlClient(e, q);
      }), [ C, h, c ]);
      var S = i((() => {
        resetClient();
        v = a({
          initialState: void 0
        });
        m();
      }), []);
      return e(u, {
        value: y
      }, e(d, {
        ...w,
        pageProps: n,
        urqlClient: y,
        resetUrqlClient: S
      }));
    };
    WithUrql.displayName = `withUrqlClient(${d.displayName || d.name || "Component"})`;
    if (d.getLayout) {
      WithUrql.getLayout = d.getLayout;
    }
    if (d.getInitialProps || f.ssr) {
      WithUrql.getInitialProps = async t => {
        var r = t.AppTree;
        var i = !!t.Component;
        var u = i ? t.ctx : t;
        var v = a({
          initialState: void 0
        });
        var q = p(v, u);
        if (!q.exchanges) {
          q.exchanges = [ l, o, v, s ];
        }
        var C = initUrqlClient(q, !f.neverSuspend);
        if (C) {
          u.urqlClient = C;
        }
        var g = {};
        if (d.getInitialProps) {
          g = await d.getInitialProps(t);
          if (u.res && (u.res.writableEnded || u.res.finished)) {
            return {
              ...g,
              urqlClient: C
            };
          }
        }
        if ("undefined" != typeof window) {
          return {
            ...g,
            urqlClient: C
          };
        }
        var w = {
          ...g,
          urqlClient: C
        };
        var c = i ? {
          pageProps: {},
          ...w
        } : {
          pageProps: w
        };
        if (!f.neverSuspend) {
          await n(e(r, c));
        }
        return {
          ...g,
          urqlState: v ? v.extractData() : void 0,
          urqlClient: C
        };
      };
    }
    return WithUrql;
  };
}

export { initUrqlClient, withUrqlClient };
//# sourceMappingURL=next-urql.es.js.map
